import { PlayersList } from "../../../components/player/PlayersList";
import { PlayerShortDto, PlayersFilterBy } from "../../../types/player";
import { TeamContext } from "../../../types/common";
import { FC, useEffect, useState } from "react";
import { getPlayers } from "../../../api/transport/playersTransport";
import { Loader } from "../../../components/Loader";

interface PlayersPageProps {
    teamName?: TeamContext;
}

export const PlayersPage: FC<PlayersPageProps> = ({
    teamName,
}) => {
    const [loading, setLoading] = useState(true);
    const [players, setPlayers] = useState<PlayerShortDto[]>([]);

    useEffect(() => {
        getPlayers(teamName)
            .then((data) => {
                setPlayers(data);
            })
            .finally(() => {
                setLoading(false);
            });
    }, [teamName]);

    if (loading) {
        return <Loader />;
    }

    return (
        <>
            {teamName === TeamContext.RODINA &&
                <div className="hidden sm:block relative w-full min-h-[450px] max-h-screen aspect-video bg-cover bg-[url(https://fcrodina.com/banner/0f0f5bbaeb7686a28cfd2080b360909f.jpg)]" style={{ fontFamily: 'Bebas Neue, sans-serif' }}>
                    <div className="box-border absolute left-0 right-0 bottom-0 text-center pt-2 sm:py-4 h-full w-full flex flex-col justify-end text-white">
                        <div className="text-2xl sm:text-5xl flex flex-col items-start gap-1 text-left px-1 sm:px-4  md:text-center md:flex-row md:justify-between md:items-center" style={{ textShadow: "0 3px 4px rgba(0, 0, 0, 1)" }}>
                            <a href="/team/ex-rodina/" className="text-3xl">Игроки «Родины» в других командах</a>
                            <a href="#profiles" className="uppercase">
                                К профайлам игроков
                            </a>
                        </div>
                    </div>
                </div>
            }
            <div className="p-2 pt-6 max-w-[1000px] mx-auto" id="profiles">
                <PlayersList
                    defaultFilter={PlayersFilterBy.Position}
                    players={players as PlayerShortDto[]}
                />
            </div>
        </>
    );
};